import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const H = { key: 0 }, V = { key: 1 }, h = { key: 2 }, w = { key: 3 }, L = { key: 4 }, k = { key: 5 }, M = {
  name: "ScalarIconArrowDownLeft"
}, y = /* @__PURE__ */ i({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = f(s);
    return (p, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(p.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", H, t[0] || (t[0] = [
        n("path", { d: "M200.49,72.48,93,180h75a12,12,0,0,1,0,24H64a12,12,0,0,1-12-12V88a12,12,0,0,1,24,0v75L183.51,55.51a12,12,0,0,1,17,17Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", V, t[1] || (t[1] = [
        n("path", {
          d: "M168,192H64V88Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M197.66,58.34a8,8,0,0,0-11.32,0L116,128.69,69.66,82.34A8,8,0,0,0,56,88V192a8,8,0,0,0,8,8H168a8,8,0,0,0,5.66-13.66L127.31,140l70.35-70.34A8,8,0,0,0,197.66,58.34ZM72,184V107.31l38.34,38.34h0L148.69,184Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", h, t[2] || (t[2] = [
        n("path", { d: "M197.66,69.66,127.31,140l46.35,46.34A8,8,0,0,1,168,200H64a8,8,0,0,1-8-8V88a8,8,0,0,1,13.66-5.66L116,128.69l70.34-70.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", w, t[3] || (t[3] = [
        n("path", { d: "M196.24,68.24,78.48,186H168a6,6,0,0,1,0,12H64a6,6,0,0,1-6-6V88a6,6,0,0,1,12,0v89.52L187.76,59.76a6,6,0,0,1,8.48,8.48Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", L, t[4] || (t[4] = [
        n("path", { d: "M197.66,69.66,83.31,184H168a8,8,0,0,1,0,16H64a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v84.69L186.34,58.34a8,8,0,0,1,11.32,11.32Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", k, t[5] || (t[5] = [
        n("path", { d: "M194.83,66.83,73.66,188H168a4,4,0,0,1,0,8H64a4,4,0,0,1-4-4V88a4,4,0,0,1,8,0v94.34L189.17,61.17a4,4,0,1,1,5.66,5.66Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
